{
  "search": "Iskanje",
  "searchWithin": "Iščite znotraj"
}
